import { useState } from "react";
import { fmtIDR } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { CreditCard } from "lucide-react";

const TENORS = [3, 6, 9, 12];
const PROVIDERS = [
  { key: "akulaku", name: "Akulaku", rate: 0.0295, color: "#E4002B" },
  { key: "kredivo", name: "Kredivo", rate: 0.026, color: "#0B2A6B" },
  { key: "spaylater", name: "ShopeePayLater", rate: 0.0295, color: "#EE4D2D" },
];

const monthly = (price, rate, tenor) => Math.round((price + price * rate * tenor) / tenor);

export function InstallmentButton({ product }) {
  const [open, setOpen] = useState(false);
  const price = Number(product?.sell_price || 0);
  return (
    <>
      <button
        onClick={() => setOpen(true)}
        data-testid={`cicilan-${product.id}`}
        title="Simulasi Cicilan"
        className="p-1.5 text-slate-500 hover:text-sky-600 align-middle"
      >
        <CreditCard className="w-4 h-4" />
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-xl">
          <DialogHeader><DialogTitle>Simulasi Cicilan — {product.name}</DialogTitle></DialogHeader>
          <div className="py-1">
            <div className="text-sm text-slate-500 mb-3">Harga produk: <span className="font-mono-num font-semibold text-slate-800">{fmtIDR(price)}</span></div>
            {price <= 0 ? (
              <p className="text-sm text-amber-600 bg-amber-50 border border-amber-100 rounded-lg px-3 py-2">Harga jual belum diisi, tidak bisa menghitung cicilan.</p>
            ) : (
              <div className="overflow-x-auto rounded-lg border border-slate-200">
                <table className="w-full text-sm">
                  <thead className="bg-slate-50 border-b border-slate-200">
                    <tr>
                      <th className="px-3 py-2 text-left font-medium text-slate-500">Penyedia</th>
                      {TENORS.map((t) => <th key={t} className="px-3 py-2 text-right font-medium text-slate-500">{t} bln</th>)}
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-slate-100">
                    {PROVIDERS.map((p) => (
                      <tr key={p.key} data-testid={`cicilan-row-${p.key}`}>
                        <td className="px-3 py-2">
                          <span className="inline-block px-2.5 py-1 rounded-md text-xs font-semibold text-white" style={{ backgroundColor: p.color }}>{p.name}</span>
                        </td>
                        {TENORS.map((t) => (
                          <td key={t} className="px-3 py-2 text-right font-mono-num">{fmtIDR(monthly(price, p.rate, t))}<span className="text-slate-400 text-[10px]">/bln</span></td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
            <p className="mt-3 text-xs text-slate-400 italic">*Estimasi cicilan dapat berubah sesuai syarat dan ketentuan masing-masing aplikasi.</p>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
